
import { getFavouriteTripsForTodayAction } from "../../../Actions/LogicActions/Search/GetFavouriteTripsForTodayAction";
import { destinationBookNowAction } from "../../../Actions/UIActions/CMSDestination/DestinationBookNowAction";
import { _eventBus } from "../../../core/events/EventBus";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { StepFlow } from "../../../core/flows/StepFlow";
import { evtTree } from "../../../Orchestrator/ConstantTree";
import { ICMSBookNowParams } from "../../../Orchestrator/Types/Interface/ICmsDestination";

export class FavouriteTripsStep extends StepFlow {
    get stepName() { return "FavouriteTripsStep"; }

    async onEventSetup(): Promise<void> {
        // Disabled — getFavouriteTripsForTodayAction calls /retailer/offers.
        // Re-enable here if/when the widget is brought back.
        // this.registerEventSubscription(
        //     _eventBus.on({
        //         eventName: evtTree.favouriteTrips.Get,
        //         handler: async () => {
        //             getFavouriteTripsForTodayAction.execute();
        //         }
        //     })
        // );

        this.registerEventSubscription(
            _eventBus.on<ICMSBookNowParams, void>({
                eventName: evtTree.DestinationDetail.BookNow.Click,
                handler: async ({ data }) => {
                    if (data) {
                        destinationBookNowAction.setParams(data!);
                        destinationBookNowAction.execute();
                    }
                },
            })
        );
    }

    async onExecute(): Promise<void> {
        if (window && window.location.href.includes("/search")) {
            console.log("FavouriteTripsStep Init Step Execute...");
            this.eventBus.emit({
                eventName: evtTree.favouriteTrips.Get,
            });
        }
    }
}
export const favouriteTripsStepDeclaration = new StepDefinition({
    stepName: "FavouriteTripsStep",
    stepClass: FavouriteTripsStep
});
